<script>
// Components
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import UserProfile from "@/router/views/users/user-profile";

// Services
import UsersDataService from "@/services/UsersDataService";

// Helpers
import Storage from "@/helpers/storage";
import UserUtils from '@/helpers/users';
import DateUtils from '@/helpers/date';
import HelperUtils from '@/helpers/helper';
import {authComputed} from "@/state/helpers";

// External Components
import {VueTabs, VTab} from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css';
import CoolLightBox from 'vue-cool-lightbox';
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
import countriesISO from "i18n-iso-countries";
import isEmpty from "is-empty";


export default {
  page: {
    localePicker: () => import(`vue2-datepicker/locale/${this.$i18n.locale}`),
    title: "Users Search",
    meta: [
      {
        name: "description",
        content: appConfig.description
      },
    ],
  },
  components: {
    Layout,
    UserProfile,
    PageHeader,
    VueTabs,
    VTab,
    CoolLightBox,
  },

  computed: {
    ...authComputed
  },

  methods: {
    ...UserUtils,
    ...HelperUtils,
    ...DateUtils,
    isEmpty,

    getCountry(user) {
      return UserUtils.getCountryName(countriesISO, user.country.toUpperCase(), this.$i18n.locale)
    },

    getRequestParams(page, pageSize, orderBy) {
      let params = {};

      if (page) {
        params["page"] = page - 1;
      }

      if (pageSize) {
        params["size"] = pageSize;
      }

      if (orderBy) {
        params["order"] = orderBy;
      }

      return params;
    },

    handlePageChange(value) {
      this.pageSelected = value;
      this.searchUsersUpdatesToVerify();
    },

    handleFilterChange() {
      this.pageSelected = 1;
      this.searchUsersUpdatesToVerify();
    },

    getImage(userId, mediaId, elt) {
      return Storage.getUserMedia(userId, mediaId, elt);
    },

    getMediaThumb() {
      if (this.users.length > 0)
        this.users.forEach(user => {
          if (user.photo && user.photo.length > 0)
            Storage.getUserMedia(user.userId, user.photo, "verify-member-" + user.documentId);
        });
    },

    searchUsersUpdatesToVerify() {
      const params = this.getRequestParams(
          this.pageSelected,
          this.pageSizes.selected,
      );

      this.isLoading = true;
      UsersDataService.getUsersUpdatesToVerify(params)
          .then(response => {
            const { items, totalItems } = response.data;
            const users = [];
            if (items.length > 0) {
              for (const item of items) {
                users.push(UserUtils.normalizeUpdates(item));
              }
            }

            this.users = users;
            this.count = totalItems;
            this.getMediaThumb();
            this.isLoading = false;
          })
          .catch(error => {
            this.isLoading = false;
            window.console.error(error);
            this.$toast.error(error.message);
          })
    },

    openUserPane() {
      if (!this.isUserPaneDisplayed) {
        this.isUserPaneDisplayed = true;
      }
    },

    closeUserPane() {
      this.userTabsActive = '';
      this.isUserPaneDisplayed = false;
    },

    showUser(user) {
      const isUserAlreadyDisplayed = this.userTabs.findIndex(x => x.userId === user.userId);
      let forceShow = false;
      if (isUserAlreadyDisplayed === -1) {
        this.userTabs.push(user);
        forceShow = true;
      }

      this.openUserPane();

      if (forceShow || (!forceShow && this.userTabsActive !== user.userId)) {
        this.userTabsActive = '';
        setTimeout(() => { this.userTabsActive = user.userId; }, 100);
      }
    },

    showMedia(user, type) {
      const mediaId = String(type === 0 ? user.photo : user.video.replace(".jpg", ".mp4")).replace("th_", "");
      Storage.getUserMediaUrl(user.userId, mediaId)
        .then((url) => {
          const media = {
            "id": 1,
            "userId": user.userId,
            "mediaId": mediaId,
            "createdAt":"",
            "typeMedia": type,
            "src": url,
            "title":"1/1",
          };

          this.showUserMedia([media], 0);
        });
    },

    showUserMedia(media, index) {
      this.userMedia.media = media;
      this.userMedia.index = index;
    },

    processUpdates(user) {
      const params = {
        adminId: this.getUser.uid,
        userId: user.userId,
        reason: user.reason,
        old: user.updatesData.old,
        new: user.updatesData.new,
      };
      return UsersDataService
          .checkedUserUpdate(user.documentId, params)
          .then(() => {
            this.markUpdateVerified(user);
            this.$toast.success("Changement marqué comme traité");
          })
          .catch(error => {
            this.$toast.error(error.message);
          });
    },

    markUpdateVerified(user) {
      this.count--;

      const index = this.users.findIndex(item => item.documentId === user.documentId);
      if (index >= 0)
        this.users.splice(index, 1);
    },

    removeUserTab(userId) {
      const index = this.userTabs.findIndex(x => x.userId === userId);
      if (index > -1)
        this.userTabs.splice(index, 1);

      if (this.userTabs.length === 0)
        this.closeUserPane();
    },

    showUserContextMenu(event, user) {
      this.$refs.userContextMenu.showMenu(event, user)
    },

    processUserContextMenu(event) {
        const { item, option } = event;
        switch (option.value) {
          case "show":
            this.showUser(item);
            break;

          case "process":
            this.processUpdates(item);
            break;
        }
    },
  },
  data() {
    return {
      isLoading: false,
      userMedia: {
        media: [],
        index: -1
      },
      optionsContext: [
        {
          name: this.$t("show_user"),
          value: 'show'
        },
        {
          type: "divider"
        },
        {
          name: "Terminer",
          value: 'process',
        },
      ],
      isProcessingAction: false,
      users: [],
      userTabs:[],
      userTabsActive: '',
      images: [],
      count: 0,
      photos:[],
      title: this.$t("menuitems.members.updates"),
      pageSelected: 1,
      pageSizes: {
        options: ['20', '50', '100'],
        selected: '20'
      },
      isUserPaneDisplayed: false,
    };
  },

  created() {
    countriesISO.registerLocale(require("i18n-iso-countries/langs/"+this.$i18n.locale+".json"));
    this.searchUsersUpdatesToVerify();
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="position-relative">

      <b-button
          class="position-fixed"
          style="top: 77px; right: 15px;z-index:150"
          v-show="!isUserPaneDisplayed && userTabs.length > 0"
          @click="openUserPane"
          variant="outline-primary">
        <i class="bx bxs-cog"></i> Show Panel
      </b-button>

      <!-- Loader -->
      <div class="row d-flex justify-content-center">
        <vue-ellipse-progress
            v-show="isLoading"
            :loading="isLoading"
            :angle="-90"
            color="#50a5f1"
            emptyColor="#999"
            emptyColorFill="#f8f8fb"
            :size="100"
            :thickness="3"
            :emptyThickness="2"
            lineMode="out 2"
            animation="bounce 700 400"
            fontColor="#666"
            :half="false"
            class="mt-5 mb-5"
            fontSize="1rem">
        </vue-ellipse-progress>
      </div>

      <!-- Top list tools -->
      <div class="row mb-3">
        <div class="col-lg-auto col-12">
          <!-- Display settings -->
          <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleFilterChange">
            <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
          </b-select>
          {{ count }} {{ $t('resultsCount') }}
        </div>
        <!-- Pagination -->
        <div class="col-lg-auto col-12">
          <div class="m-1 pagination-rounded">
            <b-pagination
                v-model="pageSelected"
                :total-rows="count"
                :per-page="pageSizes.selected"
                first-number
                last-number
                @change="handlePageChange"
                aria-controls="users-list"
            ></b-pagination>
          </div>
        </div>
      </div>

      <!-- Result list -->
      <div class="row" v-if="!isLoading && users.length > 0">
        <div class="table-responsive">
          <table
              id="users-list"
              class="table project-list-table table-centered table-borderless align-middle">
            <thead class="table-light">
            <tr>
              <th scope="col">Date</th>
              <th scope="col">Type</th>
              <th scope="col">{{ $t("users.user") }}</th>
              <th scope="col">Nouveau</th>
              <th scope="col">Ancien</th>
              <th scope="col">{{ $t("action") }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="user in users" :key="user.userId"
                @contextmenu.prevent.stop="showUserContextMenu($event, user)"
                :class="{
                'bg-light': user.disabled === 1
                }">
              <td>
                <p class="text-muted font-size-12">
                  <i class="bx bx-calendar-event"></i>{{ formatDateString(user.updateCreatedAt, 'DD MMM YYYY HH:mm') }}
                  <br><small>{{ user.documentId }}</small>
                </p>
              </td>
              <td>
                  <span
                      class="badge"
                      :class="{
                        'bg-danger text-light': `${user.reason}` === 'name',
                        'bg-info text-light': `${user.reason}` === 'description',
                      }"
                  >{{ user.reason }}</span
                  >
              </td>
              <td>
                <div class="media" v-if="user.userId !== null">
                  <div class="avatar-xs">
                    <img
                        :id="`verify-member-${user.documentId}`"
                        :src="require('@/assets/images/users/default-user.png')"
                        class="d-flex rounded-circle avatar-xs" />
                  </div>
                  <div class="media-body ms-1">
                    <h5 class="font-size-12 mb-0">
                      <span
                          :class="{
                          'text-primary': user.sex === 1,
                          'text-danger': user.sex === 2,
                          'text-dark': user.sex === 0,
                        }"
                      >
                        {{ user.name || '-' }}
                      </span> {{ getAge(user.birth) }}</h5>
                    <small class="text-muted">#{{ user.userId }}</small>
                  </div>
                </div>
              </td>
              <td>
                <small>Nouveau:</small><br />
                {{ isEmpty(user.updatesData.new) ? "no data" : user.updatesData.new }}
              </td>
              <td>
                <small>Ancien:</small><br />
                {{ isEmpty(user.updatesData.old) ? "no data" : user.updatesData.old }}
              </td>
              <td>
                  <vue-ellipse-progress
                      v-show="isProcessingAction"
                      :loading="isProcessingAction"
                      :angle="-90"
                      color="#50a5f1"
                      emptyColor="#999"
                      emptyColorFill="#f8f8fb"
                      :size="30"
                      :thickness="3"
                      :emptyThickness="2"
                      lineMode="out 2"
                      animation="bounce 700 400"
                      fontColor="#666"
                      :half="false"
                      class="mt-5 mb-5"
                      fontSize="1rem">
                  </vue-ellipse-progress>
                <b-dropdown
                    class="card-drop"
                    variant="white"
                    menu-class="dropdown-menu-end"
                    right
                    toggle-class="p-0"
                >
                  <template v-slot:button-content>
                    <i class="mdi mdi-dots-horizontal font-size-18"></i>
                  </template>
                  <b-dropdown-item
                      href="javascript: void(0);"
                      @click="showUser(user)"
                  >{{ $t("show_user") }}</b-dropdown-item>
                  <b-dropdown-item
                      href="javascript: void(0);"
                      @click="processUpdates(user)"
                  >Marquer comme traité</b-dropdown-item>
                </b-dropdown>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Result Empty -->
      <div class="row" v-if="!isLoading && users.length === 0">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Empty Result</h4>
              <p>No profiles updates found. Try later.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- bottom list tools -->
      <div class="row mb-3">
        <!-- Display settings -->
        <div class="col-lg-auto col-12">
          <b-select class="form-select d-inline w-auto m-1" v-model="pageSizes.selected" @change="handleFilterChange">
            <option v-for="size in pageSizes.options" :key="size" :value="size">{{ size }} {{ $t('pageSize') }}</option>
          </b-select>
        </div>
        <!-- Pagination -->
        <div class="col-lg-auto col-12">
          <div class="m-1 pagination-rounded">
            <b-pagination
                v-model="pageSelected"
                :total-rows="count"
                :per-page="pageSizes.selected"
                first-number
                last-number
                @change="handlePageChange"
                aria-controls="users-list"
            ></b-pagination>
          </div>
        </div>
      </div>

    </div>
    <b-sidebar
        id="sidebar-right" right
        v-model="isUserPaneDisplayed"
      >
      <vue-tabs
          v-model="userTabsActive"
          active-tab-color="#213213"
          active-text-color="white">
        <v-tab v-for="userTab in userTabs" :key="userTab.userId" :title="userTab.userId" >
          <div slot="title">{{ userTab.name }} <i @click.stop="removeUserTab(userTab.userId)" class="bx bx-x-circle" ></i></div>
          <UserProfile
              :userId="null"
              :user="userTab"
              v-on:SHOW_MEDIA="showUserMedia"
              >
          </UserProfile>
        </v-tab>
      </vue-tabs>
    </b-sidebar>

    <vue-simple-context-menu
        element-id="userContextMenu"
        :options="optionsContext"
        ref="userContextMenu"
        @option-clicked="processUserContextMenu"
    />

    <CoolLightBox
        :items="userMedia.media"
        :index="userMedia.index"
        :effect="'fade'"
        @close="userMedia.index = null">
    </CoolLightBox>
  </Layout>
</template>

<style>
  .cursor-pointer {
    cursor:pointer;
  }

  .avatar-sm {
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
  }

  .gender-img {
    max-width: 30px;
    margin-right: 10px;
  }

  .b-sidebar-right {
    width:35%;
  }

  .b-sidebar-body {
    padding:16px;
  }

</style>
